import { useTranslation } from "react-i18next";
import cn from "classnames";

import { Body } from "capitalrx-components-2.0/lib/typography";

import styles from "./styles.module.scss";

export const Footer = () => {
  const { t: translate } = useTranslation();
  const footerContainerClass = cn(styles["FooterContainerWide"]);

  return (
    <footer className={styles["FooterWrapper"]}>
      <div className={styles["FooterContent"]}>
        <div className={footerContainerClass}>
          <Body>{translate("FOOTER.copyright")}</Body>

          <span>
            <a href="https://www.cap-rx.com/legal#legal-notice-privacy-policy">{translate("FOOTER.legalNotices")}</a>
          </span>
        </div>
      </div>
    </footer>
  );
};
